<template>
    <div>
        <section class="about_us section-padding">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-12">
                        <div class="section-header text-justify">
                            <h3 class="text-center text-uppercase">
                                AVISO DE PRIVACIDAD PROTECCIÓN DE DATOS
                                PERSONALES REDAUTOS
                            </h3>
                            <p>se permite informar que:</p>
                            <p>
                                En cumplimiento a lo estipulado en la Ley 1581
                                de 2012 y a lo previsto en el numeral 3 y el
                                parágrafo del artículo 10 del Decreto 1377 de
                                2013, con el objeto de informar a todas las
                                personas cuyos datos personales se encuentran en
                                nuestras bases de datos, y teniendo en cuenta la
                                imposibilidad de solicitar autorización en forma
                                individual, REDAUTOS informa que hace uso del
                                mecanismo alternativo establecido en el citado
                                numeral y manifiesta que los datos personales
                                incluidos en sus bases de datos se han
                                recopilado para el desarrollo de diversos
                                procedimientos relacionados directamente con su
                                objeto social.
                            </p>
                            <p>
                                El uso y manejo de los mismos, se efectúa bajo
                                estrictos estándares de responsabilidad, dentro
                                de los cuales está el respeto al debido proceso
                                y a la protección de la información.
                            </p>
                            <p>
                                Los datos registrados en nuestras bases de datos
                                son, entre otros: datos personales, tales como,
                                teléfonos, correos electrónicos, fecha de
                                nacimiento, edad, información del vehículo,
                                cédula y demás especificados en la política. En
                                todo caso en cualquier momento el titular de la
                                información podrá revocar su consentimiento y
                                ejercer su derecho a la supresión de datos
                                personales consagrado en la Ley 1581 de 2012.
                            </p>
                            <p>
                                Si Usted desea consultar información o solicitar
                                la supresión de sus datos personales de nuestras
                                bases de datos, agradecemos se comunique dentro
                                de los 30 días siguientes a la publicación del
                                presente aviso al correo electrónico
                                valentina.osorio@avaluauto.com, o al teléfono
                                (57) 3218731567. Si decide no hacerlo, vencido
                                el referido plazo, consideraremos autorizado el
                                tratamiento de sus datos personales. Lo
                                anterior, sin perjuicio del derecho que asiste
                                al titular de información en cualquier tiempo de
                                consultar, conocer, actualizar sus datos
                                personales, o solicitar su supresión o
                                rectificación.
                            </p>
                            <p>
                                REDAUTOS puede contener hipervínculos a otros
                                sitios de internet, los cuales a su vez pueden
                                tener políticas de privacidad diferentes a las
                                de REDAUTOS.
                            </p>
                            <p>
                                Para más información, por favor, consulte la
                                Política de Tratamiento de Información en el
                                correo arriba referido.
                            </p>
                            <p>
                                <b>Nombre de la Empresa:</b> REDAUTOS <br />
                                <b> Nombre del Encargado:</b> JUAN MARTIN GONZALEZ POSADA
                                <br />
                                <b>Domicilio:</b> Calle 5 # 14-47
                                <br />
                                <b>Teléfono:</b> (57) 320 6660716
                                <br />
                                <b>Correo electrónico:</b>
                                servicioalcliente@redautos.com
                                <br />
                                <b>Página web:</b> www.redautos.com
                            </p>
                            <h3 class="text-center text-uppercase">
                                POLITICA DE TRATAMIENTO DE DATOS PERSONALES
                            </h3>
                            <p>
                                A continuación, se enuncian las políticas de
                                Tratamiento de información que rigen la
                                actividad desarrollada por REDAUTOS y el manejo
                                de sus bases de datos. El presente documento se
                                desarrolla en cumplimiento de la Ley 1581 de
                                2012, “Por la cual se dictan disposiciones
                                generales para la protección de datos
                                personales”, según la cual todas las entidades
                                públicas o privadas que manejen datos
                                personales, deberán adoptar un manual interno de
                                políticas y procedimientos para garantizar el
                                adecuado cumplimiento de la ley y en especial,
                                para asegurar el efectivo ejercicio de los
                                derechos de los titulares. Toda la información
                                recibida por REDAUTOS a través de sus diferentes
                                canales de comunicación, en medios digitales o
                                impresos, y que conforma nuestras bases de
                                datos, obtenidos de clientes, proveedores,
                                empleados o contratistas, y demás titulares de
                                información, se rige por las siguientes
                                políticas de uso. Si usted se encuentra
                                relacionado en alguna de nuestras bases de datos
                                es porque ha tenido o mantiene una relación
                                comercial con REDAUTOS o porque ha entregado sus
                                datos de manera voluntaria en eventos y
                                actividades desarrollados por REDAUTOS, o
                                directamente en nuestra oficina.
                            </p>
                            <p>
                                REDAUTOS es una empresa dedicada al sector
                                automotriz, con facilidades en la investigación
                                de mercados, ofreciendo herramientas para
                                promover el mercado de vehículos, razón por la
                                cual queremos que conozca qué información
                                recolectamos y qué hacemos con ella. Nuestra
                                política de privacidad aplica para toda la
                                información que recolectamos sobre usted.
                            </p>
                            <p>
                                Información del responsable del tratamiento de
                                los datos:
                            </p>
                            <p>
                                <b>Nombre de la Empresa:</b> REDAUTOS <br />
                                <b> Nombre del Encargado:</b> JUAN MARTIN GONZALEZ POSADA
                                <br />
                                <b>Domicilio:</b> Calle 5 # 14-47
                                <br />
                                <b>Teléfono:</b> (57) 320 6660716
                                <br />
                                <b>Correo electrónico:</b>
                                servicioalcliente@redautos.com
                                <br />
                                <b>Página web:</b> www.redautos.com
                            </p>
                            <p>
                                <b>
                                    1.- NORMATIVIDAD LEGAL Y ÁMBITO DE
                                    APLICACIÓN</b
                                >
                                La presente Política de Tratamiento de Datos
                                Personales es elaborada de conformidad con lo
                                dispuesto en la Constitución Política, la Ley
                                1581 de 2012, el Decreto Reglamentario 1377 d e
                                2013 y demás disposiciones que la adicionen,
                                modifiquen o reglamenten y será aplicada por
                                REDAUTOS, en adelante REDAUTOS respecto de la
                                recolección, almacenamiento, uso, circulación,
                                supresión y de todas aquellas actividades que
                                constituyan tratamiento de datos personales.
                                Cualquier vacío en la normatividad citada se
                                interpretará de conformidad con las
                                disposiciones de la legislación colombiana en
                                general, así como a la luz de los artículos 15 y
                                20 de la Constitución Nacional de la República
                                de Colombia. De esta manera, REDAUTOS manifiesta
                                que garantiza los derechos de la privacidad, la
                                intimidad, el buen nombre, en el tratamiento de
                                los datos personales, y en consecuencia todas
                                sus actuaciones se regirán por los principios de
                                legalidad, finalidad, libertad, veracidad o
                                calidad, transparencia, acceso y circulación
                                restringida, seguridad y confidencialidad. Todas
                                las personas que, en desarrollo de diferentes
                                actividades contractuales, comerciales,
                                virtuales, entre otras, sean permanentes u
                                ocasionales, llegaran a suministrar a REDAUTOS
                                cualquier tipo de información o dato personal,
                                podrán conocerla, actualizarla y rectificarla.
                            </p>
                            <p>
                                <b>2.- DEFINICIONES</b>
                                Para efectos de la ejecución de la presente
                                Política y de conformidad con la normatividad
                                legal, serán aplicables las siguientes
                                definiciones: a)
                                <b>Autorización</b>: Consentimiento previo,
                                expreso e informado del Titular de la
                                información y datos personales para que REDAUTOS
                                pueda llevar a cabo actividades que impliquen
                                tratamiento de dichos datos personales; b)
                                <b>Aviso de privacidad</b>: Documento físico,
                                electrónico o en cualquier otro formato generado
                                por el Responsable que se pone a disposición del
                                Titular para el tratamiento de sus datos
                                personales. En el Aviso de Privacidad se
                                comunica al Titular la información relativa a la
                                existencia de la Política de Tratamiento de
                                información que le serán aplicables, la forma de
                                acceder a la misma y la finalidad del
                                tratamiento que se pretende dar a los datos
                                personales; c) <b>Base de Datos</b>: Conjunto
                                organizado de datos personales que sea objeto de
                                Tratamiento por parte de REDAUTOS; d)
                                <b>Dato personal</b>: Cualquier información
                                vinculada o que pueda asociarse a una o varias
                                personas naturales determinadas o determinables;
                                e) <b> Dato público</b> : Es el dato calificado
                                como tal según los mandatos de la ley o de la
                                Constitución Política y aquel que no sea
                                semiprivado, privado o sensible. Son públicos,
                                entre otros, los datos relativos al estado civil
                                de las personas, a su profesión u oficio, a su
                                calidad de comerciante o de servidor público y
                                aquellos que puedan obtenerse sin reserva
                                alguna. Por su naturaleza, los datos públicos
                                pueden estar contenidos, entre otros, en
                                registros públicos, documentos públicos, gacetas
                                y boletines oficiales, así como en sentencias
                                judiciales debidamente ejecutoriadas que no
                                estén sometidas a reserva por expresa
                                disposición legal; f) <b>Dato privado</b> : Es
                                el dato que por su naturaleza íntima o reservada
                                sólo es relevante para el titular; g)
                                <b>Datos sensibles</b> : Se entiende por datos
                                sensibles aquellos que afectan la intimidad del
                                Titular o cuyo uso indebido puede generar su
                                discriminación, tales como aquellos que revelen
                                el origen racial o étnico, la orientación
                                política, las convicciones religiosas o
                                filosóficas, la pertenencia a sindicatos,
                                organizaciones sociales, de derechos humanos o
                                que promueva intereses de cualquier partido
                                político o que garanticen los derechos y
                                garantías de partidos políticos de oposición,
                                así como los datos relativos a la salud, a la
                                vida sexual y reproductiva y los datos
                                biométricos, que contienen información que puede
                                afectar la intimidad de las personas, es por
                                esto, que se han adoptado todas las medidas de
                                seguridad razonables para su seguridad y ha
                                obtenido las autorizaciones debidas para el
                                desarrollo de sus labores, por otra parte,
                                también ha informado a sus clientes, aspirantes,
                                empleados activos y retirados y a sus
                                proveedores cómo se realiza el tratamiento, cuál
                                es su finalidad y cuál es la vigencia de su
                                información en nuestras bases de datos. h)
                                <b>Encargado del Tratamiento</b> : Persona
                                natural o jurídica, pública o privada, que por
                                sí misma o en asocio con otros, realice el
                                Tratamiento de datos personales por cuenta del
                                Responsable del Tratamiento; i)
                                <b> Responsable del Tratamiento </b> : Persona
                                natural o jurídica, pública o privada, que por
                                sí misma o en asocio con otros, decida sobre la
                                base de datos y/o el Tratamiento de los datos;
                                j) <b>Titular</b> : Persona natural cuyos datos
                                personales sean objeto de Tratamiento; k)
                                <b>Tratamiento</b> : Cualquier operación o
                                conjunto de operaciones sobre datos personales,
                                tales como la recolección, almacenamiento, uso,
                                circulación o supresión de los mismos; l)
                                <b>Transferencia</b> : La transferencia de datos
                                tiene lugar cuando el responsable y/o encargado
                                del tratamiento de datos personales, ubicado en
                                Colombia, envía la información o los datos
                                personales a un receptor, quien a su vez es
                                responsable del tratamiento, y se encuentra
                                ubicado dentro o fuera del país; m)
                                <b>Transmisión</b> : La transmisión es una
                                modalidad de tratamiento de las informaciones y
                                datos personales que implica la comunicación de
                                los mismos dentro o fuera del territorio de la
                                República de Colombia, cuando tenga por objeto
                                la realización de actividades de tratamiento por
                                el encargado, pero siempre por cuenta del
                                responsable; n)
                                <b>Registro Nacional de Bases de Datos</b>
                                : Es el directorio público de las bases de datos
                                personales sujetas a actividades de tratamiento
                                que operan en el país, cuya administración está
                                a cargo de la Superintendencia de Industria y
                                Comercio como máxima autoridad administrativa de
                                vigilancia y control en materia de tratamiento
                                de datos personales y hábeas data.
                            </p>
                            <b>
                                3.- FINALIDAD CON LA QUE SE EFECTÚA LA
                                RECOLECCIÓN DE DATOS PERSONALES Y TRATAMIENTO DE
                                LOS MISMOS E INFORMACIÓN QUE SE RECOLECTA:
                                REDAUTOS</b
                            ><span>
                                podrá hacer uso de los datos personales para:
                            </span>
                            <p>
                                a) Poseer un registro de las personas que
                                realicen los formularios, encuestas, blogs y que
                                se encuentren en los medios virtuales utilizados
                                por REDAUTOS. b) Conocer, observar y analizar
                                los gustos y preferencias del mercado de
                                consumidores de los servicios que brinda
                                REDAUTOS y posibles aliados comerciales c)
                                Proveer los servicios y/o los productos
                                ofrecidos por REDAUTOS y requeridos por sus
                                usuarios. d) Informar sobre nuevos productos o
                                servicios y/o sobre cambios en los mismos; e)
                                Evaluar la calidad del servicio; f) Realizar
                                estudios internos sobre hábitos de consumo; g)
                                Enviar al correo físico, electrónico, o a través
                                de cualquier otro medio análogo y/o digital de
                                comunicación creado o por crearse, información
                                sobre los productos y/o servicios ofrecidos por
                                REDAUTOS y/o por terceras personas.
                            </p>
                            <p>
                                Respecto de los datos (i) recolectados
                                directamente por el personal de REDAUTOS, ii)
                                Obtenidos mediante registro virtual en la página
                                web o aplicativo, (iii) obtenidos de las
                                videograbaciones que se realizan por personal de
                                REDAUTOS, éstos podrán utilizarse para la
                                elaboración y promoción de programas pedagógicos
                                y comerciales.
                            </p>
                            <p>
                                <u>Finalidad del análisis web y los Cookies</u>
                                : a) impulsar una mejora continua de la
                                experiencia online que tienen tanto los
                                usuarios, clientes potenciales y los Clientes
                                registrados (Asesores), b) ayuda a medir los
                                resultados de las campañas de atracción de
                                tráfico, c) estimar cómo cambia el tráfico a un
                                sitio web tras el lanzamiento de una nueva
                                campaña publicitaria. El análisis web
                                proporciona información sobre el número de
                                visitantes de un sitio web y el número de
                                visitas a páginas. Ayuda a medir el tráfico y
                                las tendencias de popularidad que es útil para
                                la investigación de mercado, recordar accesos,
                                conocer si ya se ha visitado la página para
                                actuar en consecuencia, por ejemplo, mostrando o
                                no cierto contenido o recordar a un usuario.
                                Cuando un usuario introduce su nombre de usuario
                                y contraseña, se almacena una cookie para que no
                                deba ingresarlas para cada página del servidor.
                            </p>
                            <p>
                                <u
                                    >Finalidad de información de clientes
                                    potenciales persona natural o jurídica</u
                                >
                                : Tener una base de datos de los clientes
                                potenciales interesados en nuestros servicios y
                                con las cuales podamos establecer una relación
                                comercial, y ofrecer servicios de cotización
                                vehicular.
                            </p>
                            <p>
                                <u
                                    >Finalidad de información de Clientes
                                    registrados (Asesores) persona natural o
                                    jurídica</u
                                >: Autenticar al cliente al momento de ingresar
                                a la plataforma, brindarle los servicios
                                adquiridos, entender sus necesidades e intereses
                                por el registro de su actividad en la página y
                                de esta manera, ofrecerle una mejor experiencia
                                de servicio, brindarle acceso a ofertas de
                                vehículos, efectuar avalúos de vehículos,
                                comercializar productos, así como mantenerlo
                                informado de las novedades que ofrecemos.
                            </p>
                            <p>
                                <u
                                    >Finalidad de información de datos de los
                                    aspirantes, empleados activos y retirados de
                                    REDAUTOS</u
                                >: La información personal de los aspirantes,
                                empleados activos y retirados incluyendo su
                                núcleo familiar, se da con la finalidad de
                                cumplir con las obligaciones que emanan de las
                                respectivas relaciones laborales. Tales
                                obligaciones incluyen, entre otras, pagos de
                                nómina, otorgamiento de beneficios, evaluaciones
                                de desempeño, mejoramiento de los procesos de
                                capacitación,, la atención de solicitudes, la
                                generación de certificados y constancias, la
                                afiliación a las entidades del Sistema de
                                Protección Social, la realización de actividades
                                de Bienestar Laboral, el levantamiento de
                                registros contables, los reportes a autoridades
                                de control y vigilancia, contacto con el
                                empleado, causar impuestos, comunicación en caso
                                de ausencia, entre otros. Gestión del área de
                                desempeño organizacional.
                            </p>
                            <p>
                                Así mismo, se podrá recolectar información
                                personal de aspirantes que se presenten para
                                procesos de selección con la finalidad de poder
                                adelantar los procesos respectivos de
                                contratación de personal. Adicionalmente, se
                                podrá almacenar indefinidamente la información
                                de quienes se presenten para estos procesos y
                                utilizarla en procesos de selección de personal
                                futuros.
                            </p>
                            <p>
                                Por otro lado, REDAUTOS podrá grabar y tomar
                                audios, videos o fotos de los empleados en el
                                desarrollo de los eventos, capacitaciones o
                                demás actividades llevadas a cabo. Estos audios,
                                videos o fotos podrán ser utilizados por
                                REDAUTOS en boletines, informes, publicaciones,
                                y en general en cualquier actividad de la
                                organización incluso una vez el empleado se
                                retire.
                            </p>
                            <p>
                                <u
                                    >Finalidad de información de proveedores y
                                    contratistas </u
                                >:
                            </p>
                            <ol>
                                <li>
                                    Conocer, actualizar y rectificar información
                                    de los datos personales.
                                </li>
                                <li>
                                    Invitar a cotizar, contratar y presentar
                                    propuestas de trabajo en el proceso que le
                                    corresponda a la empresa que provea el tipo
                                    de servicios solicitados.
                                </li>
                                <li>
                                    Realizar control y seguimiento de las
                                    obligaciones derivadas de los procesos de
                                    contratación, con el fin de que se cumplan
                                    los parámetros de calidad y seguridad
                                    establecidos en los mismos, así como en el
                                    caso de aquellos que por su tipo de trabajo
                                    deban asumir el encargo de alguna base de
                                    datos de REDAUTOS, en cuyo caso deberán
                                    cumplir a cabalidad con todos los
                                    requerimientos de protección de datos y
                                    demás aspectos legales considerados en el
                                    contrato de proveedores.
                                    <p>
                                        De lo contrario, se suministrará la
                                        información y los datos personales a las
                                        autoridades de control y vigilancia,
                                        administrativas nacionales e
                                        internacionales, por requerimiento
                                        legal, administrativo o reglamentario
                                        y/o usar o revelar esta información y
                                        datos personales en defensa de los
                                        derechos de propiedad de REDAUTOS y de
                                        nuestros clientes para la detección o
                                        prevención de fraude, aprehensión o
                                        persecución, de actos criminales.
                                    </p>
                                </li>
                                <li>
                                    Consolidar una Base de datos de proveedores
                                    potenciales para futuros requerimientos de
                                    productos y servicios que requiera la
                                    empresa.
                                </li>
                                <li>
                                    Llevar a cabo el proceso de estudio de
                                    propuestas, pagos, consolidación,
                                    organización, actualización, aseguramiento,
                                    acreditación, estadística, reportes,
                                    interacción, auditoría, encuestas, defensa
                                    jurídica y gestión de las actuaciones,
                                    informaciones y actividades de la empresa.
                                </li>
                                <li>
                                    Verificar si el proveedor se encuentra
                                    reportado en alguna de las listas
                                    restrictivas relacionadas con delitos de
                                    lavados de activos y financiación del
                                    terrorismo o cualquier otra que impida
                                    establecer una relación contractual.
                                </li>
                                <li>
                                    Permitir el acceso a la información y datos
                                    personales a los auditores o terceros
                                    contratados para procesos de auditoría
                                    interna o externa propios de la actividad
                                    comercial que desarrollamos.
                                </li>
                                <li>
                                    Evaluar la capacidad e idoneidad del
                                    proveedor potencial incluyendo las personas
                                    bajo su coordinación, para atender los
                                    requerimientos de selección del proveedor
                                    mediante la verificación de los soportes que
                                    se alleguen al proceso; hoja de vida,
                                    acreditación de experiencia, soportes
                                    académicos, entre otros.
                                </li>
                                <li>
                                    Solicitar al proveedor o distribuidor y sus
                                    trabajadores destinados para la ejecución
                                    del servicio o trabajo a contratar los
                                    respectivos soportes de afiliación al
                                    sistema general de seguridad social.
                                </li>
                            </ol>
                            <p>
                                Si un dato personal es proporcionado, dicha
                                información será utilizada sólo para los
                                propósitos aquí señalados, y por tanto, REDAUTOS
                                no procederá a vender, licenciar, transmitir, o
                                divulgar la misma, salvo que: (i) exista
                                autorización expresa del Titular para hacerlo;
                                (ii) sea necesario para permitir a los
                                contratistas o agentes prestar los servicios
                                encomendados; (iii) sea necesario con el fin de
                                proveer nuestros servicios y/o productos; (iv)
                                sea necesario divulgarla a las entidades que
                                prestan servicios de mercadeo en nombre de
                                REDAUTOS o a otras entidades con las cuales se
                                tengan acuerdos de mercado conjunto; (v) la
                                información tenga relación con una fusión,
                                consolidación, adquisición, desinversión, u otro
                                proceso de restructuración de la empresa; (vi)
                                que sea requerido o permitido por la ley.
                            </p>
                            <p>
                                REDAUTOS podrá subcontratar a terceros para el
                                procesamiento de determinadas funciones o
                                información. Cuando efectivamente se subcontrate
                                con terceros el procesamiento de información
                                personal o se proporcione información personal a
                                terceros prestadores de servicios, REDAUTOS
                                advierte a dichos terceros sobre la necesidad de
                                proteger dicha información personal con medidas
                                de seguridad apropiadas, se prohíbe el uso de la
                                información para fines propios, limitándose a
                                los indicados por REDAUTOS, y se exige que no se
                                divulgue la información personal a otros.
                            </p>
                            <p>
                                <b>3.1- ANÁLISIS DE DATOS</b>
                                <span
                                    >Para efectos del tratamiento de datos cuya
                                    función para REDAUTOS, es la promoción de
                                    sus productos, administración de su personal
                                    y proveedores, es necesario entender que
                                    REDAUTOS es una empresa que se crea con el
                                    interés por potencializar la
                                    comercialización vehículos, para tal fin los
                                    datos recaudados se emplean para estudiar
                                    hábitos de consumo por zonas, intereses de
                                    vendedores y compradores de vehículos,
                                    optimizar el manejo de su personal, y
                                    control frente a sus proveedores.</span
                                >
                            </p>
                            <p>
                                Queremos manifestarle que la seguridad de sus
                                datos es lo más importante para nosotros, es por
                                esto que bajo ninguna circunstancia sus datos
                                personales (Tipo de documento, número de
                                documento, nombres, apellidos, número de
                                teléfono, e-mail) se tendrán en cuenta para
                                presentar informes de hábitos de consumo, es
                                decir que para estos efectos los datos
                                personales se disociaran para poder hacer uso de
                                los resultados sin asociarlos a una persona en
                                particular.
                            </p>

                            <p>
                                <u>Página Web</u>: las herramientas de analítica
                                web, se utiliza para obtener información
                                agrupada del tráfico que llega a los sitios web
                                según la audiencia, la adquisición, el
                                comportamiento y las conversiones que se llevan
                                a cabo en el sitio web, esta es una herramienta
                                cuyo servicio es otorgado por un intermediario
                                que entrega la información que hace referencia a
                                cómo mejorar el servicio de una página web, pero
                                bajo ningún motivo hace entrega de información
                                personal.
                            </p>
                            <p>
                                <u
                                    >Datos de clientes potenciales persona
                                    natural o jurídica</u
                                >
                                : los datos que se recopilan a través de nuestra
                                página web y nuestros agentes comerciales se
                                encargan a una plataforma de email marketing
                                propia o de terceros que permita la
                                administración de los contactos y programación
                                de acciones de mercadeo para lograr convertir
                                clientes potenciales a Clientes registrados
                                (Asesores), o para ofrecerles servicios como
                                clientes no registrados, como cotizaciones de
                                vehículos.
                            </p>
                            <p>
                                <u
                                    >Datos de Clientes registrados (Asesores)
                                    persona natural o jurídica</u
                                >: estos datos son administrados en nuestra
                                plataforma y se busca realizar análisis del
                                comportamiento en las páginas, de igual forma
                                estos datos son aportados directamente por
                                nuestros clientes, esto con el interés de saber
                                sobre sus gustos y preferencias, como también
                                para organizar medios de promoción y prestación
                                del servicio, para así, hacer de este una gran
                                experiencia, por lo tanto, contamos con archivos
                                digitales en donde podemos analizar, calcular y
                                desarrollar datos estadísticos sobre la
                                información que consideramos relevante para el
                                funcionamiento y comercialización de nuestros
                                servicios y mantener una relación comercial de
                                largo plazo con nuestros clientes.
                            </p>
                            <p>
                                <u>
                                    Datos de los aspirantes, empleados activos y
                                    retirados de REDAUTOS</u
                                >: Se cuenta con un archivo digital de las hojas
                                de vida y toda la información solicitada tanto a
                                los aspirantes como a los empleados activos y
                                retirados, para poder acceder a esta y poder
                                llevar a cabo los procesos mencionados en la
                                finalidad de este tipo de base de datos, los
                                archivos digitales se guardan en nuestros
                                servidores y computadores del área asignada para
                                tal proceso.
                            </p>
                            <p>
                                <u>Proveedores y contratistas</u>: la forma como
                                se lleva a cabo el tratamiento de la información
                                es a través de una serie de archivos digitales
                                los cuales cuentan con la información de los
                                proveedores, las propuestas realizadas a
                                REDAUTOS y el análisis de desempeño sobre la
                                labor es decir la experiencia que hemos tenido
                                con el proveedor, estos archivos digitales se
                                trabajan a partir de categorías en las cuales
                                agrupamos a los proveedores y los guardamos en
                                nuestros servidores y computadores del área
                                asignada, los contratistas y proveedores pueden
                                aportar directamente de forma presencial sus
                                datos al diligenciar formatos de vinculación
                                como proveedores en nuestras instalaciones.
                            </p>
                            <p><b>3.2- TITULARES DE LA INFORMACIÓN:</b></p>
                            <p>
                                <u>Usuarios</u>: Son todos aquellos que ingresan
                                a la página de internet ya sea persona natural o
                                persona que en nombre de una empresa visita
                                nuestra página para conocer de REDAUTOS.
                            </p>
                            <p>
                                Estas personas no se registran en nuestra página
                                web, por lo tanto, las consideramos como
                                anónimas.
                            </p>
                            <p>
                                <u>Clientes potenciales</u>: son aquellos a
                                quienes les interesa recibir notificaciones,
                                información científica y comercial por parte de
                                REDAUTOS y que para este efecto nos dejan sus
                                datos para tales envíos de información ya sea
                                virtual, en físico o a través de un agente
                                comercial. Este tipo de cliente se divide en:
                            </p>
                            <ul>
                                <li>
                                    <u>Personas naturales</u>: Personas que se
                                    encuentran interesadas en nuestros servicios
                                    o que desean adquirir información comercial
                                    de nuestra página, redes sociales o agentes
                                    comerciales y que para esto nos deja su
                                    nombre, e-mail y teléfono.
                                </li>
                                <li>
                                    <u>Empresas</u>: personas que en nombre de
                                    una empresa nos entregan sus datos (nombre
                                    de la empresa, nombre de la persona Cargo,
                                    e-mail, teléfono y dirección) con la
                                    finalidad de recibir información científica
                                    y comercial de nuestros servicios, ya sea a
                                    través de la página de internet, redes
                                    sociales, o agentes comerciales
                                </li>
                                <li>
                                    <u>Clientes registrados (Asesores)</u>: Son
                                    aquellos que para hacer uso de nuestros
                                    servicios diligencian la información de
                                    registro en nuestro sistema ya sea por la
                                    página de internet o por medio de un agente
                                    comercial.
                                </li>
                                <li>
                                    <u>Cliente Personas naturales</u>: es aquel
                                    que se registra con: Número de cédula de
                                    ciudadanía, nombre, apellidos, teléfono,
                                    dirección, e-mail, edad, y por medio del
                                    portal web solicita se le asigna una clave
                                    que deberá personalizar para hacer uso de
                                    nuestros servicios enfocados en la promoción
                                    de comercialización de vehículos.
                                </li>
                                <li>
                                    <u>Cliente empresa</u>: es aquella que se
                                    registra con: Número de NIT, Nombre de la
                                    empresa, dirección, nombres y apellidos del
                                    contacto con dicha persona jurídica, email.
                                </li>
                                <li>
                                    <u>
                                        Aspirantes, empleados activos y
                                        retirados</u
                                    >: Son aquellos que nos proveen información
                                    pertinente para sus procesos de selección y
                                    cumplimiento de las obligaciones que emanan
                                    de las relaciones laborales.
                                </li>
                                <li>
                                    <u>Proveedores y contratistas</u>: Son las
                                    personas naturales o jurídicas que abastecen
                                    a REDAUTOS con los productos y servicios
                                    necesarios para el cumplimiento de sus
                                    objetivos, es por esto que consideramos a
                                    nuestros proveedores como aliados
                                    estratégicos para para el logro de nuestra
                                    gestión.
                                </li>
                            </ul>
                            <p>
                                <b>3.3- INFORMACION RECOPILADA</b>
                                <span>
                                    Entre la información recopilada por REDAUTOS
                                    se encuentran, el nombre del usuario, edad,
                                    género, dirección de residencia, número de
                                    identificación, emails, información del
                                    perfil, teléfono celular, tipo de persona
                                    (natural, jurídica, nacional o extranjera)
                                    tipo de documento, número del mismo, lugar
                                    de expedición, compañía para la cual
                                    trabaja, datos de vehículo, nombre y
                                    apellidos, país, departamento, ciudad, nivel
                                    de estudio, títulos obtenidos, fecha de
                                    terminación de estudios, otros estudios,
                                    idiomas, experiencia laboral, nombre de
                                    empresas donde laboró anteriormente, fecha
                                    de inicio y retiro de dichas labores, jefe
                                    inmediato, teléfono de contacto del mismo,
                                    estado civil, datos de cónyuge e hijos,
                                    examen médico, eps, fondo de pensiones,
                                    fondo de cesantías, ARL, salario, jornada
                                    laboral, número de cuenta de nómina y
                                    entidad bancaria, correo empresarial.</span
                                >
                            </p>
                            <p>
                                Documentos que se solicita diligenciar y aportar
                                a titulares de datos personales: i) Formato de
                                Registro de Proveedores diligenciado, ii) Copia
                                del documento de identidad para personas
                                naturales, para personas jurídicas, copia del
                                documento de identidad del representante legal.
                                iii) Certificado de Cámara de Comercio vigente
                                del domicilio principal y la sucursal (si
                                aplica). iv) Registro Único Tributario – RUT,
                                actualizado. v) Declaración de Renta del año
                                inmediatamente anterior. vi) Estados Financieros
                                a 31 de diciembre del año inmediatamente
                                anterior: Balance General y Estados de
                                Resultados con Notas. vii) Certificados de
                                gestión de la calidad vigentes (si lo posee).
                                viii) Autorización de funcionamiento (a los que
                                aplique como: empresas de vigilancia,
                                transporte, agencias de aduana, laboratorios de
                                acreditación, comunicaciones, empresas de
                                medicina prepagada, etc.). ix) Portafolio de
                                productos y/o servicios. x) Documento vigente
                                que acredite la existencia y representación
                                legal en el país donde tiene su domicilio
                                principal con una fecha de expedición no
                                superior a 60 días, debidamente legalizados en
                                la forma prevista en las normas vigentes sobre
                                la materia, es decir, con la traducción oficial
                                si está en otro idioma y con la cadena de
                                autenticaciones, la cual está conformada por la
                                Notaría y el Consulado en el país de origen del
                                documento y por el Ministerio de Relaciones
                                Exteriores en Colombia. xi) Documento que
                                acredite la inscripción en el registro
                                correspondiente o equivalente al RUT, en el país
                                donde tiene su domicilio principal debidamente
                                apostillado. xii) Autorización de
                                funcionamiento, licencias o permisos (para los
                                casos a los que aplique como: empresas de
                                transporte, agencias de aduana, laboratorios de
                                acreditación, comunicaciones, debidamente
                                apostillado.
                            </p>
                            <p>
                                <b>3.3.1-</b>
                                <u
                                    >Información específica recolectada,
                                    dependiendo de la forma y tipo de titular</u
                                >
                            </p>
                            <ol>
                                <li>
                                    <ul>
                                        <li>
                                            <u>Página Web</u>: usted puede ser:
                                            Usuario, cliente potencial persona
                                            natural o jurídica y cliente
                                            registrado (asesores) persona
                                            natural o jurídica. y para todos
                                            estos tipos de cliente aplican los
                                            siguientes procedimientos que se
                                            ejecutan en nuestra página
                                            https://avaluauto.com/.
                                        </li>
                                        <li>
                                            <u
                                                >El Contenido o información que
                                                se recolecta es</u
                                            >: navegador de internet, computador
                                            o sistema operativo, dirección IP,
                                            velocidad de conexión, localidad
                                            geográfica, desde donde ingresa
                                            nuestra página o sitios desde los
                                            cuales se conectó a nuestra página
                                            web, de la misma manera,
                                            analizaremos el tiempo y patrones
                                            comportamiento en la página, para el
                                            mejoramiento de nuestro servicio. Se
                                            recolecta información directamente
                                            del titular a través de la página
                                            concerniente a: Nombre, cedula,
                                            teléfono, compañía para la cual
                                            trabaja, correo electrónico,
                                            ubicación, información del vehículo
                                            (Marca, línea, año, kilómetros,
                                            ciudad)
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <ul>
                                        <li>
                                            <u>Clientes Potenciales</u>: los
                                            clientes potenciales para REDAUTOS
                                            se dividen en dos opciones:
                                            <u>
                                                Clientes potenciales persona
                                                natural y jurídica: Clientes
                                                potenciales persona natural o
                                                empresas (Persona jurídica)</u
                                            >: Personas que en nombre suyo o de
                                            una empresa se encuentran
                                            interesadas en nuestros servicios o
                                            que desean adquirir información
                                            comercial de nuestra página, redes
                                            sociales o agentes comerciales
                                            cotizar o comercializar vehículos
                                            para este caso la información que se
                                            recolecta es: Empresa, Nombres y
                                            apellidos, cargo que desempeña,
                                            ciudad, teléfono, correo
                                            electrónico, y en las ocasiones en
                                            las que desea obtener información
                                            científica se le solicitará Nombre,
                                            apellido y correo, información del
                                            vehículo (Marca, línea, año,
                                            kilómetros, ciudad) que deseen
                                            comercializar o cotizar.
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <ul>
                                        <li>
                                            <u>
                                                Clientes registrados (Asesores)
                                                persona natural o empresas
                                                (persona jurídica)</u
                                            >: de la misma forma en que los
                                            clientes potenciales se dividen en
                                            dos tipos, los Clientes registrados
                                            (Asesores) en nuestra empresa
                                            también se dividen en dos tipos: el
                                            cliente persona natural, el cliente
                                            empresarial, los cuales diligencian
                                            la información de registro ya sea
                                            por la página de internet o por
                                            medio de un agente comercial.
                                        </li>
                                        <li>
                                            <u> Cliente Personas naturales</u>
                                            : Es el tipo de cliente que se
                                            registra en nuestra base de datos
                                            con los datos que se mencionan a
                                            continuación: tipo de documento,
                                            número de documento, nombres y
                                            apellidos, e-mail, teléfono de
                                            contacto, departamento, ciudad,
                                            dirección, asignación de contraseña,
                                            edad, adicionalmente REDAUTOS puede
                                            publicar testimonios de sus clientes
                                            en nuestra página web, los cuales
                                            pueden contener información personal
                                            como nombre y fotografía de
                                            vehículo, información del vehículo
                                            (Marca, línea, año, kilómetros,
                                            ciudad) que deseen comercializar o
                                            cotizar.
                                        </li>
                                        <li>
                                            <u> Cliente empresa: </u> Es aquel
                                            que contrata los servicios de
                                            REDAUTOS para el suministro de
                                            productos ofrecidos por REDAUTOS,
                                            entre los datos que aporta mediante
                                            el portal web o agente comercial,
                                            existen razón social, Nit,
                                            identificación del representante
                                            legal, dirección, e-mail, teléfono,
                                            información del vehículo (Marca,
                                            línea, año, kilómetros, ciudad).
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <ul>
                                        <li>
                                            <u
                                                >Datos de los aspirantes,
                                                empleados activos y retirados de
                                                REDAUTOS</u
                                            >
                                            : Esta es la base de datos de
                                            nuestros aspirantes, empleados
                                            activos y retirados y es manejada
                                            por el área de recursos humanos.
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <ul>
                                        <li>
                                            <u>Proveedores y contratistas</u>:
                                            Son las personas naturales o
                                            jurídicas que abastecen a REDAUTOS
                                            con los productos y servicios
                                            necesarios para el cumplimiento de
                                            sus objetivos, es por esto que
                                            consideramos a nuestros proveedores
                                            como aliados estratégicos para para
                                            el logro de nuestra gestión.
                                            <br />
                                            Los proveedores y contratistas que
                                            son seleccionados dentro de los
                                            procesos de contratación serán
                                            evaluados periódicamente con el
                                            propósito de conocer su
                                            comportamiento en el desarrollo de
                                            los contratos y así poder definir
                                            objetivos encaminados al
                                            mejoramiento continuo que garanticen
                                            el suministro de bienes o servicios
                                            bajo condiciones de calidad y
                                            eficiencia.
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <ul>
                                        <li>
                                            <u>Formas de pago</u>: Son los datos
                                            que se recolectan al momento de
                                            hacer los pagos de los servicios que
                                            se desean adquirir por nuestra
                                            página web, este servicio es se hace
                                            por medio de un tercero el cual se
                                            encarga de realizar la transacción y
                                            cuenta con métodos de seguridad para
                                            que se realice una transacción
                                            segura, sin embargo, las políticas
                                            de privacidad que manejan pueden ser
                                            diferentes a las que maneja REDAUTOS
                                            razón por la cual, cuando una
                                            persona realiza el pago de nuestros
                                            servicio, debe seleccionar
                                            explícitamente la opción de aceptar
                                            en las casillas de las políticas de
                                            privacidad tanto de REDAUTOS como de
                                            las políticas del intermediario por
                                            el cual se ejecutan los pagos, por
                                            tal razón lo invitamos a conocer las
                                            políticas de privacidad del
                                            intermediario así como su finalidad,
                                            tratamiento y vigencia.
                                        </li>
                                    </ul>
                                </li>
                            </ol>
                            <p>
                                <b>
                                    3.4- FORMA EN LA QUE SE RECOPILA LA
                                    INFORMACIÓN</b
                                >
                                <span>
                                    : Dicha información es obtenida por las
                                    siguientes formas: a) Proporcionada
                                    directamente por los usuarios mediante
                                    e-mail, vía telefónica, de manera
                                    presencial, por página web, plataforma
                                    virtual, por medio de agentes comerciales, o
                                    al ingresar a la plataforma, esto es al
                                    agotarse los registros solicitados
                                    correspondientes a solicitud del servicio.
                                    b) Recopilando información personal
                                    correspondiente a nombre, identificación,
                                    teléfono, correos, dirección, en detalle la
                                    recolección se efectúa de la siguiente
                                    forma:
                                </span>
                            </p>
                            <p>
                                <u>Páginas Web</u> - Recolección automática de
                                datos: Nuestras páginas Web utilizan una
                                tecnología conocida cómo cookies, los cuales son
                                archivos que se pueden descargar en su equipo a
                                través de las páginas web. Son herramientas que
                                tienen un papel esencial para la prestación de
                                numerosos servicios de la sociedad de la
                                información. Entre otros, permiten a una página
                                web almacenar y recuperar información sobre los
                                hábitos de navegación de un usuario o de su
                                equipo y, dependiendo de la información
                                obtenida, se pueden utilizar para reconocer al
                                usuario y mejorar el servicio ofrecido. También
                                se recopila información directamente del titular
                                mediante diligenciamiento de formularios.
                            </p>
                            <p>
                                <u> Tipos de cookies:</u> Según quien sea la
                                entidad que gestione el dominio desde donde se
                                envían las cookies y trate los datos que se
                                obtengan se pueden distinguir dos tipos:
                            </p>
                            <ul>
                                <li>
                                    <u>Cookies propias</u>: aquéllas que se
                                    envían al equipo terminal del usuario desde
                                    un equipo o dominio gestionado por el propio
                                    editor y desde el que se presta el servicio
                                    solicitado por el usuario.
                                </li>
                                <li>
                                    <u>Cookies de terceros</u> : aquéllas que se
                                    envían al equipo terminal del usuario desde
                                    un equipo o dominio que no es gestionado por
                                    el editor, sino por otra entidad que trata
                                    los datos obtenidos través de las cookies.
                                </li>
                            </ul>
                            <p>
                                En el caso de que las cookies sean instaladas
                                desde un equipo o dominio gestionado por el
                                propio editor, pero la información que se recoja
                                mediante éstas sea gestionada por un tercero, no
                                pueden ser consideradas como cookies propias.
                            </p>
                            <p>
                                Existe también una segunda clasificación según
                                el plazo de tiempo que permanecen almacenadas en
                                el navegador del cliente, pudiendo tratarse de:
                            </p>
                            <ul>
                                <li>
                                    <u> Cookies de sesión</u> : diseñadas para
                                    recabar y almacenar datos mientras el
                                    usuario accede a una página web. Se suelen
                                    emplear para almacenar información que solo
                                    interesa conservar para la prestación del
                                    servicio solicitado por el usuario en una
                                    sola ocasión (ejemplo: una lista de
                                    productos adquiridos).
                                </li>
                                <li>
                                    <u>Cookies persistentes</u> : los datos
                                    siguen almacenados en el terminal y pueden
                                    ser accedidos y tratados durante un periodo
                                    definido por el responsable de la cookie, y
                                    que puede ir de unos minutos a varios años.
                                </li>
                            </ul>
                            <p>
                                Por último, existe otra clasificación con seis
                                tipos de cookies según la finalidad para la que
                                se traten los datos obtenidos:
                            </p>
                            <ul>
                                <li>
                                    <u>Cookies técnicas</u> : aquellas que
                                    permiten al usuario la navegación a través
                                    de una página web, plataforma o aplicación y
                                    la utilización de las diferentes opciones o
                                    servicios que en ella existan como, por
                                    ejemplo, controlar el tráfico y la
                                    comunicación de datos, identificar la
                                    sesión, acceder a partes de acceso
                                    restringido, recordar los elementos que
                                    integran un pedido, realizar el proceso de
                                    compra de un pedido, realizar la solicitud
                                    de inscripción o participación en un evento,
                                    utilizar elementos de seguridad durante la
                                    navegación, almacenar contenidos para la
                                    difusión de vídeos o sonido o compartir
                                    contenidos a través de redes sociales.
                                </li>
                                <li>
                                    <u> Cookies de personalización</u> :
                                    permiten al usuario acceder al servicio con
                                    algunas características de carácter general
                                    predefinidas en función de una serie de
                                    criterios en el terminal del usuario como
                                    por ejemplo serian el idioma, el tipo de
                                    navegador a través del cual accede al
                                    servicio, la configuración regional desde
                                    donde accede al servicio, etc.
                                </li>
                                <li>
                                    <u>Cookies de análisis</u>: permiten al
                                    responsable de las mismas, el seguimiento y
                                    análisis del comportamiento de los usuarios
                                    de los sitios web a los que están
                                    vinculadas. La información recogida mediante
                                    este tipo de cookies se utiliza en la
                                    medición de la actividad de los sitios web,
                                    aplicación o plataforma y para la
                                    elaboración de perfiles de navegación de los
                                    usuarios de dichos sitios, aplicaciones y
                                    plataformas, con el fin de introducir
                                    mejoras en función del análisis de los datos
                                    de uso que hacen los usuarios del servicio.
                                </li>
                                <li>
                                    <u>Cookies publicitarias</u>: permiten la
                                    gestión, de la forma más eficaz posible, de
                                    los espacios publicitarios.
                                </li>
                                <li>
                                    <u>Cookies de publicidad comportamental</u>
                                    : almacenan información del comportamiento
                                    de los usuarios obtenida a través de la
                                    observación continuada de sus hábitos de
                                    navegación, lo que permite desarrollar un
                                    perfil específico para mostrar publicidad en
                                    función del mismo.
                                </li>
                                <li>
                                    <u>Cookies de redes sociales externas</u>:
                                    se utilizan para que los visitantes puedan
                                    interactuar con el contenido de diferentes
                                    plataformas sociales (facebook, youtube,
                                    twitter, linkedIn, etc.) y que se generen
                                    únicamente para los usuarios de dichas redes
                                    sociales. Las condiciones de utilización de
                                    estas cookies y la información recopilada se
                                    regulan por la política de privacidad de la
                                    plataforma social correspondiente.
                                </li>
                            </ul>
                            <p>
                                <b>3.4.1- </b>
                                <u
                                    >Clientes potenciales persona natural o
                                    empresas (Persona jurídica):</u
                                >
                                el proceso de recolección de datos para clientes
                                potenciales se realiza de dos maneras: a través
                                de nuestras páginas de internet y por medio de
                                agentes comerciales.
                            </p>
                            <ul>
                                <li>
                                    El proceso de recolección de datos a través
                                    de nuestra página web se realiza cuando la
                                    persona que se encuentra interesada en
                                    nuestros servicios y desea contactarnos nos
                                    suministra sus datos de contacto o también
                                    cuando la persona desea adquirir información
                                    científica de nuestra página y para poder
                                    enviársela nos deja sus datos de contacto.
                                </li>
                                <li>
                                    El proceso de recolección de datos por parte
                                    de nuestros agentes comerciales se
                                    desarrolla en el proceso de la relación
                                    comercial con la persona y donde se
                                    intercambian datos de contacto.
                                </li>
                            </ul>
                            <p>
                                <b>3.4.2- </b>
                                <u
                                    >Clientes registrados (Asesores) persona
                                    natural o jurídica:</u
                                >
                            </p>
                            <ul>
                                <li>
                                    Clientes persona natural: se realiza a
                                    través de un formulario que se encuentra en
                                    la página web y que se debe diligenciar al
                                    momento de solicitar un servicio de
                                    REDAUTOS, también se efectúa el registro
                                    mediante agentes comerciales.
                                </li>
                                <li>
                                    Cliente empresarial: Se realiza por medio de
                                    un formulario de registro como cliente, el
                                    cual se diligencia a través de la página una
                                    vez se ha desarrollado el proceso comercial
                                    con nuestro agente comercial.
                                </li>
                            </ul>
                            <p>
                                <b>3.4.3 -</b>
                                <u
                                    >Datos de los aspirantes, empleados activos
                                    y retirados de REDAUTOS:</u
                                >
                                la forma como se recopilan los datos se lleva a
                                cabo durante el proceso de selección, en el cual
                                se solicitan las hojas de vida y datos
                                importantes para el proceso, hasta que finaliza
                                con la contratación de la persona o de las
                                personas idóneas para ejercer el cargo.
                            </p>
                            <p>
                                <b>3.4.4 -</b>
                                <u>Proveedores y contratistas:</u> En el momento
                                en que se presentan las necesidades de
                                proveedores y contratistas se realizan búsquedas
                                e inscripción de los candidatos que deseen
                                brindar propuestas de trabajo en donde se
                                analizan la capacidad técnica, organizacional,
                                experiencia y conocimientos sobre el tema en
                                cuestión, así como los aspectos jurídicos
                                necesarios para respectivo proceso de
                                contratación del proveedor.
                            </p>
                            <p>
                                <b
                                    >4. -PRINCIPIOS APLICABLES AL TRATAMIENTO DE
                                    DATOS PERSONALES: REDAUTOS</b
                                >, en su calidad de responsable del tratamiento
                                de datos personales, declara que la presente
                                Política de Tratamiento de Datos Personales se
                                encuentra ajustada a las disposiciones de orden
                                legal contenidas en la ley 1581 de 2012 y en el
                                Decreto Único Reglamentario 1074 de 2015, por lo
                                que en el desarrollo de las actividades de
                                tratamiento, en la aplicación de la misma, y en
                                la interpretación que de ella se hiciere con
                                fundamento en las normas antes citadas, se
                                aplicarán armónicamente los siguientes
                                principios:
                            </p>
                            <p>
                                a) Principio de finalidad: El Tratamiento de los
                                datos personales recogidos debe obedecer a una
                                finalidad legítima, la cual debe ser informada
                                al Titular; b) Principio de libertad: El
                                Tratamiento sólo puede llevarse a cabo con el
                                consentimiento, previo, expreso e informado del
                                Titular. Los datos personales no podrán ser
                                obtenidos o divulgados sin previa autorización,
                                o en ausencia de mandato legal o judicial que
                                releve el consentimiento; c) Principio de
                                veracidad o calidad: La información sujeta a
                                Tratamiento debe ser veraz, completa, exacta,
                                actualizada, comprobable y comprensible. No será
                                efectuado el Tratamiento de datos parciales,
                                incompletos, fraccionados o que induzcan a
                                error; d) Principio de transparencia: En el
                                Tratamiento debe garantizarse el derecho del
                                Titular a obtener de REDAUTOS en cualquier
                                momento y sin restricciones, información acerca
                                de la existencia de datos que le conciernan; e)
                                Principio de acceso y circulación restringida:
                                El Tratamiento se sujeta a los límites que se
                                derivan de la naturaleza de los datos
                                personales, de las disposiciones de la presente
                                ley y la Constitución. Los datos personales,
                                salvo la información pública, y lo dispuesto en
                                la autorización otorgada por el titular del
                                dato, no podrán estar disponibles en Internet u
                                otros medios de divulgación o comunicación
                                masiva, salvo que el acceso sea técnicamente
                                controlable para brindar un conocimiento
                                restringido sólo a los Titulares o terceros
                                autorizados; f) Principio de seguridad: La
                                información sujeta a Tratamiento por parte de
                                REDAUTOS se deberá proteger mediante el uso de
                                las medidas técnicas, humanas y administrativas
                                que sean necesarias para otorgar seguridad a los
                                registros evitando su adulteración, pérdida,
                                consulta, uso o acceso no autorizado o
                                fraudulento; g) Principio de confidencialidad:
                                Todas las personas que intervengan en el
                                Tratamiento de datos personales están obligadas
                                a garantizar la reserva de la información,
                                inclusive después de finalizada su relación con
                                alguna de las labores que comprende el
                                Tratamiento.
                            </p>
                            <p>
                                <b>PARÁGRAFO PRIMERO:</b> En el evento que se
                                recolecten datos personales sensibles, el
                                Titular podrá negarse a autorizar su
                                Tratamiento.
                            </p>
                            <p>
                                <b>
                                    5. DERECHOS DE LOS TITULARES DE DATOS
                                    PERSONALES OBJETO DE TRATAMIENTO POR PARTE
                                    DE REDAUTOS:
                                </b>
                                Los titulares de datos personales por sí o por
                                intermedio de su representante y/o apoderado o
                                su causahabiente podrán ejercer los siguientes
                                derechos, respecto de los datos personales que
                                sean objeto de tratamiento por parte de
                                REDAUTOS:
                            </p>
                            <p>
                                a) Derecho de acceso: En virtud del cual podrá
                                acceder a los datos personales que estén bajo el
                                control de REDAUTOS, para efectos de
                                consultarlos de manera gratuita al menos una vez
                                cada mes calendario, y cada vez que existan
                                modificaciones sustanciales de las Políticas de
                                Tratamiento de la información que motiven nuevas
                                consultas; b) Derecho de actualización,
                                rectificación y supresión: En virtud del cual
                                podrá solicitar la actualización, rectificación
                                y/o supresión de los datos personales objeto de
                                tratamiento, de tal manera que se satisfagan los
                                propósitos del tratamiento; éste derecho se
                                podrá ejercer, entre otros, frente a datos
                                parciales, inexactos, incompletos, fraccionados,
                                que induzcan a error o frente a aquellos cuyo
                                tratamiento esté expresamente prohibido por ley
                                o no haya sido autorizado por el titular; c)
                                Derecho a solicitar prueba de la autorización:
                                salvo en los eventos en los cuales, según las
                                normas legales vigentes, no se requiera de la
                                autorización para realizar el tratamiento; d)
                                Derecho a ser informado respecto del uso del
                                dato personal; e) Derecho a presentar quejas
                                ante la Superintendencia de Industria y
                                Comercio: por infracciones a lo dispuesto en la
                                normatividad vigente sobre tratamiento de datos
                                personales; f) Derecho a requerir el
                                cumplimiento de las órdenes emitidas por la
                                Superintendencia de Industria y Comercio; g)
                                Derecho a revocar la autorización otorgada a
                                REDAUTOS, cuando en el tratamiento de los datos
                                personales REDAUTOS no respetare los principios,
                                derechos y garantías constituciones y legales.
                            </p>
                            <p>
                                <b> PARÁGRAFO PRIMERO:</b> Para efectos del
                                ejercicio de los derechos antes descritos tanto
                                el titular como la persona que lo represente
                                deberá demostrar su identidad y, de ser el caso,
                                la calidad en virtud de la cual representa al
                                titular.
                            </p>
                            <p>
                                <b>PARÁGRAFO SEGUNDO:</b> La revocatoria y/o
                                supresión procederá cuando la Superintendencia
                                de Industria y Comercio haya determinado que en
                                el Tratamiento el Responsable o Encargado han
                                incurrido en conductas contrarias a esta ley y a
                                la Constitución.
                            </p>
                            <p>
                                <b>PARÁGRAFO TERCERO:</b> Los derechos de los
                                menores de edad serán ejercidos por medio de las
                                personas que estén facultadas para
                                representarlos.
                            </p>
                            <p>
                                <b> 6. DEBERES DE REDAUTOS:</b> Todos los
                                obligados a cumplir esta política deben tener
                                presente que REDAUTOS está obligada a cumplir
                                los deberes que al respecto imponga la ley. En
                                consecuencia, se deben cumplir las siguientes
                                obligaciones:
                            </p>
                            <ul>
                                <li>
                                    <b>
                                        A. Deberes cuando actúa como
                                        responsable:</b
                                    >
                                    (i) Solicitar y conservar, en las
                                    condiciones previstas en esta política,
                                    copia de la respectiva autorización otorgada
                                    por el titular. (ii) Informar de manera
                                    clara y suficiente al titular sobre la
                                    finalidad de la recolección y los derechos
                                    que le asisten por virtud de la autorización
                                    otorgada. (iii) Informar a solicitud del
                                    titular sobre el uso dado a sus datos
                                    personales (iv) Tramitar las consultas y
                                    reclamos formulados en los términos
                                    señalados en la presente política (v)
                                    Procurar el cumplimiento de los principios
                                    de veracidad, calidad, seguridad y
                                    confidencialidad en los términos
                                    establecidos en la siguiente política (vi)
                                    Conservar la información bajo las
                                    condiciones de seguridad necesarias para
                                    impedir su adulteración, pérdida, consulta,
                                    uso o acceso no autorizado o fraudulento.
                                    (vii) Actualizar la información cuando sea
                                    necesario. (viii) Rectificar los datos
                                    personales cuando ello sea procedente.
                                </li>
                                <li>
                                    <b>
                                        B. Deberes cuando obra como Encargado
                                        del tratamiento de datos personales.</b
                                    >
                                    Si realiza el tratamiento de datos en nombre
                                    de otra entidad u organización (Responsable
                                    del tratamiento) deberá cumplir los
                                    siguientes deberes: (i) Establecer que el
                                    Responsable del tratamiento esté autorizado
                                    para suministrar los datos personales que
                                    tratará como Encargado (ii) Garantizar al
                                    titular, en todo tiempo, el pleno y efectivo
                                    ejercicio del derecho de hábeas data. (iii)
                                    Conservar la información bajo las
                                    condiciones de seguridad necesarias para
                                    impedir su adulteración, pérdida, consulta,
                                    uso o acceso no autorizado o fraudulento.
                                    (iv) Realizar oportunamente la
                                    actualización, rectificación o supresión de
                                    los datos. (v) Actualizar la información
                                    reportada por los Responsables del
                                    tratamiento dentro de los cinco (5) días
                                    hábiles contados a partir de su recibo. (vi)
                                    Tramitar las consultas y los reclamos
                                    formulados por los titulares en los términos
                                    señalados en la presente política. (vii)
                                    Registrar en la base de datos la leyenda
                                    “reclamo en trámite” en la forma en que se
                                    establece en la presente política. (viii)
                                    Insertar en la base de datos la leyenda
                                    “información en discusión judicial” una vez
                                    notificado por parte de la autoridad
                                    competente sobre procesos judiciales
                                    relacionados con la calidad del dato
                                    personal. (ix) Abstenerse de circular
                                    información que esté siendo controvertida
                                    por el titular y cuyo bloqueo haya sido
                                    ordenado por la Superintendencia de
                                    Industria y Comercio. (x) Permitir el acceso
                                    a la información únicamente a las personas
                                    autorizadas por el titular o facultadas por
                                    la ley para dicho efecto. (xi) Informar a la
                                    Superintendencia de Industria y Comercio
                                    cuando se presenten violaciones a los
                                    códigos de seguridad y existan riesgos en la
                                    administración de la información de los
                                    titulares. (xii) Cumplir las instrucciones y
                                    requerimientos que imparta la
                                    Superintendencia de Industria y Comercio.
                                </li>
                                <li>
                                    <b>
                                        C. Deberes cuando realiza el tratamiento
                                        a través de un Encargado</b
                                    >
                                    (i) Suministrar al Encargado del tratamiento
                                    únicamente los datos personales cuyo
                                    tratamiento esté previamente autorizado.
                                    Para efectos de la transmisión nacional o
                                    internacional de los datos se deberá
                                    suscribir un contrato de transmisión de
                                    datos personales o pactar cláusulas
                                    contractuales según lo establecido en el
                                    artículo 25 del decreto 1377 de 2013(ii)
                                    Garantizar que la información que se
                                    suministre al Encargado del tratamiento sea
                                    veraz, completa, exacta, actualizada,
                                    comprobable y comprensible. (iii) Comunicar
                                    de forma oportuna al Encargado del
                                    tratamiento todas las novedades respecto de
                                    los datos que previamente le haya
                                    suministrado y adoptar las demás medidas
                                    necesarias para que la información
                                    suministrada a este se mantenga actualizada.
                                    (iv) Informar de manera oportuna al
                                    Encargado del tratamiento las
                                    rectificaciones realizadas sobre los datos
                                    personales para que éste proceda a realizar
                                    los ajustes pertinentes. (v) Exigir al
                                    Encargado del tratamiento, en todo momento,
                                    el respeto a las condiciones de seguridad y
                                    privacidad de la información del titular.
                                    (vi) Informar al Encargado del tratamiento
                                    cuando determinada información se encuentre
                                    en discusión por parte del titular, una vez
                                    se haya presentado la reclamación y no haya
                                    finalizado el trámite respectivo.
                                </li>
                                <li>
                                    <b>
                                        D. Deberes respecto de la
                                        Superintendencia de Industria y
                                        Comercio</b
                                    >
                                    (i) Informarle las eventuales violaciones a
                                    los códigos de seguridad y la existencia de
                                    riesgos en la administración de la
                                    información de los titulares. (ii) Cumplir
                                    las instrucciones y requerimientos que
                                    imparta la Superintendencia de Industria y
                                    Comercio.
                                </li>
                                <li>
                                    <b>
                                        E. Deberes frente al tratamiento de
                                        información de menores de edad:
                                    </b>
                                    REDAUTOS conoce y respeta la prohibición
                                    establecida en el artículo 7 de Ley 1581 de
                                    2012 respecto del tratamiento de datos de
                                    menores de edad, salvo en aquellos casos en
                                    que los mismos sean considerados como de
                                    naturaleza pública.
                                </li>
                            </ul>
                            <p>
                                Por lo anterior, REDAUTOS abogará y respetará el
                                interés superior de éstos, asegurando un
                                absoluto respeto de sus derechos fundamentales.
                                Así mismo, se abstendrá de someter dichos datos
                                a actividades de tratamiento sin que medie la
                                respectiva autorización del representante legal
                                del menor de edad titular de la información en
                                los términos de ley y de acuerdo con la presente
                                Política de Protección de Datos, previo
                                ejercicio del derecho del menor a ser escuchado,
                                en atención a su capacidad para conocer y
                                entender los términos de la autorización que sus
                                representantes otorguen.
                            </p>
                            <p>
                                <b>
                                    7. SOLICITUD DE AUTORIZACIÓN AL TITULAR DEL
                                    DATO PERSONAL:</b
                                >
                                Con antelación y/o al momento de efectuar la
                                recolección del dato personal, REDAUTOS
                                solicitará al titular del dato su autorización
                                para efectuar su recolección y tratamiento,
                                indicando la finalidad para la cual se solicita
                                el dato, utilizando para esos efectos medios
                                técnicos automatizados, escritos u orales, que
                                permitan conservar prueba de la autorización y/o
                                de la conducta inequívoca descrita en el
                                artículo 7 del Decreto 1377 de 2013. Dicha
                                autorización se solicitará por el tiempo que sea
                                razonable y necesario para satisfacer las
                                necesidades que dieron origen a la solicitud del
                                dato y, en todo caso, con observancia de las
                                disposiciones legales que rigen sobre la
                                materia.
                            </p>
                            <p>
                                <b>7.1. MÉTODOS PARTICULARES DE ACEPTACIÓN:</b>
                            </p>
                            <p>
                                <u> Página Web:</u> Aceptación de la Política de
                                cookies: REDAUTOS en su página web
                                https://avaluauto.com asume que usted acepta el
                                uso de cookies al no tener configurado su
                                navegador de internet para bloquear los Cookies,
                                no obstante, la información sobre su Política de
                                cookies se encuentra en la parte inferior de
                                nuestra página en el enlace que describe esta
                                política de privacidad.
                            </p>
                            <p>
                                También contamos con el aviso que les informa a
                                nuestros usuarios sobre el uso de Cookies en
                                nuestra página web y si desea aceptarlos.
                            </p>
                            <p>
                                <u>Desactivación y eliminación de cookies:</u>
                                Usted tiene la opción de permitir, bloquear o
                                eliminar las cookies instaladas en tu equipo
                                mediante la configuración de las opciones del
                                navegador instalado en su equipo. Al desactivar
                                cookies, algunos de los servicios disponibles
                                podrían dejar de estar operativos. La forma de
                                deshabilitar las cookies es diferente para cada
                                navegador, pero normalmente puede hacerse desde
                                el menú Herramientas u Opciones. También puede
                                consultarse el menú de Ayuda del navegador donde
                                puedes encontrar instrucciones. El usuario podrá
                                en cualquier momento elegir qué cookies quiere
                                que funcionen en este sitio web.
                            </p>
                            <p>
                                <u
                                    >Clientes potenciales persona natural o
                                    empresas (Persona jurídica):</u
                                >
                                la autorización se dará por el cliente potencial
                                al momento de diligenciar los formularios que
                                están dispuestos en la página para establecer un
                                contacto comercial o para recibir información
                                por parte de REDAUTOS, este formulario dejará
                                una casilla que el cliente señala al estar de
                                acuerdo con las políticas de privacidad de
                                REDAUTOS.
                            </p>
                            <p>
                                Esta casilla sirve para demostrar que el usuario
                                que nos facilita sus datos personales consiente
                                el tratamiento de los mismos expresamente.
                            </p>
                            <p>
                                Esta casilla sirve para demostrar que el usuario
                                que nos facilita sus datos personales consiente
                                el tratamiento de los mismos expresamente.
                            </p>
                            <p>
                                Los datos recopilados por agentes comerciales,
                                implicarán la suscripción de un formato de
                                autorización de tratamiento de datos personales.
                            </p>
                            <p>
                                <u>Clientes registrado persona natural:</u> el
                                formulario que las personas diligencian cuando
                                adquieren un producto de REDAUTOS, dejará una
                                casilla que el cliente señala al estar de
                                acuerdo con las políticas de privacidad y los
                                términos de servicio de REDAUTOS.
                            </p>
                            <p>
                                Esta casilla sirve para demostrar que el usuario
                                que nos facilita sus datos personales consiente
                                el tratamiento de los mismos expresamente.
                            </p>
                            <p>
                                Los datos recopilados por agentes comerciales,
                                implicarán la suscripción de un formato de
                                autorización de tratamiento de datos personales.
                            </p>
                            <p>
                                <u>Cliente registrado empresarial: </u> la firma
                                de un contrato comercial y de encargado del
                                tratamiento de datos personales por parte de
                                REDAUTOS y la empresa que contrata los
                                servicios, previo análisis de este, son prueba
                                de la autorización en la que ambas partes
                                reconocen mutuamente la capacidad legal
                                suficiente para suscribir este contrato de
                                encargo de tratamiento de datos personales y
                                para quedar obligadas en la representación en
                                que respectivamente actúan, en los términos
                                convenidos en él. Si el registro se hace a
                                través de la página web, deberá autorizar
                                expresamente el tratamiento mediante la casilla
                                de autorización.
                            </p>
                            <p>
                                <u
                                    >Datos de los aspirantes, empleados activos
                                    y retirados de REDAUTOS:</u
                                >
                                se entiende que quien someta a consideración de
                                REDAUTOS su hoja de vida, por cualquier medio, o
                                firme contrato de trabajo con esta organización
                                entiende y autoriza el tratamiento de sus datos
                                personales, durante el proceso de selección el
                                aspirante suscribirán una autorización de
                                tratamiento de datos personales, los contratos
                                laborales y el reglamento interno contemplarán
                                de igual forma dicha autorización.
                            </p>
                            <p>
                                <u>Proveedores y distribuidores:</u> en el
                                momento en que un proveedor y/o distribuidor se
                                registra como proveedor y/o distribuidor
                                potencial de REDAUTOS, presta su consentimiento
                                libre y expreso para el manejo de sus datos
                                tanto personales como empresariales. De igual
                                forma se suscribirá una autorización de
                                tratamiento de datos personales para estos al
                                momento de diligenciar el formato de inscripción
                                como proveedores y/o distribuidores.
                            </p>
                            <p>
                                <b
                                    >8. LIMITACIONES TEMPORALES AL TRATAMIENTO
                                    DE LOS DATOS PERSONALES. REDAUTOS</b
                                >
                                solo podrá recolectar, almacenar, usar o
                                circular los datos personales durante el tiempo
                                que sea razonable y necesario, de acuerdo con
                                las finalidades que justificaron el tratamiento,
                                atendiendo a las disposiciones aplicables a la
                                materia de que se trate y a los aspectos
                                administrativos, contables, fiscales, jurídicos
                                e históricos de la información. Una vez cumplida
                                la o las finalidades del tratamiento y sin
                                perjuicio de normas legales que dispongan lo
                                contrario, procederá a la supresión de los datos
                                personales en su posesión. No obstante lo
                                anterior, los datos personales deberán ser
                                conservados cuando así se requiera para el
                                cumplimiento de una obligación legal o
                                contractual.
                            </p>
                            <p>
                                <b
                                    >9. PROCEDIMIENTO PARA EL EJERCICIO DE LOS
                                    DERECHOS DE LOS TITULARES DEL DATO
                                    PERSONAL:</b
                                >
                                Los derechos de los titulares podrán ser
                                ejercidos a través de los canales que han sido
                                habilitados para dicho efecto. A través de la
                                dirección de correo electrónico:
                            </p>
                            <p>valentina.osorio@avaluauto.com</p>
                            <p>
                                El titular del dato personal o quien ejerza su
                                representación podrá formular o enviar su
                                petición, queja o reclamo, de lunes a viernes,
                                de 8:00 a.m a 5:00 p.m, a través de las líneas
                                telefónicas o las direcciones, según se registra
                                a continuación:
                            </p>
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <th>Correo Electrónico</th>
                                        <th>Dirección</th>
                                        <th>Teléfono</th>
                                        <th>Personal Encargado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>valentina.osorio@avaluauto.com</td>
                                        <td>Calle 5 # 14-47</td>
                                        <td>(57) 3218731567</td>
                                        <td>VALENTINA OSORIO CORDOBA</td>
                                    </tr>
                                </tbody>
                            </table>
                            <p>
                                La petición, queja o reclamo deberá contener la
                                identificación del Titular, la descripción de
                                los hechos que dan lugar al reclamo, la
                                dirección, y acompañando los documentos que se
                                quiera hacer valer. Si el reclamo resulta
                                incompleto, se requerirá al interesado dentro de
                                los cinco (5) días siguientes a la recepción del
                                reclamo para que subsane las fallas.
                                Transcurridos dos (2) meses desde la fecha del
                                requerimiento, sin que el solicitante presente
                                la información requerida, se entenderá que ha
                                desistido del reclamo. En caso de que quien
                                reciba el reclamo no sea competente para
                                resolverlo, dará traslado a quien corresponda en
                                un término máximo de dos (2) días hábiles e
                                informará de la situación al interesado. Una vez
                                recibido el reclamo completo, se incluirá en la
                                base de datos una leyenda que diga “reclamo en
                                trámite” y el motivo del mismo, en un término no
                                mayor a dos (2) días hábiles. Dicha leyenda
                                deberá mantenerse hasta que el reclamo sea
                                decidido. El término máximo para atender el
                                reclamo será de quince (15) días hábiles
                                contados a partir del día siguiente a la fecha
                                de su recibo. Cuando no fuere posible atender el
                                reclamo dentro de dicho término, se informará al
                                interesado los motivos de la demora y la fecha
                                en que se atenderá su reclamo, la cual en ningún
                                caso podrá superar los ocho (8) días hábiles
                                siguientes al vencimiento del primer término.
                            </p>
                            <p>
                                De igual forma, por el mismo canal de
                                comunicación podrá solicitar consultas sobre la
                                información personal del Titular que este
                                contenida en cualquiera de las bases de datos.
                                La consulta será atendida en un término máximo
                                de diez (10) días hábiles contados a partir de
                                la fecha de recibo de la misma. Cuando no fuere
                                posible atender la consulta dentro de dicho
                                término, se informará al interesado, expresando
                                los motivos de la demora y señalando la fecha en
                                que se atenderá su consulta, la cual en ningún
                                caso podrá superar los cinco (5) días hábiles
                                siguientes al vencimiento del primer término.
                            </p>
                            <p>
                                <b> 10. MEDIDAS DE SEGURIDAD:</b> En desarrollo
                                del principio de seguridad establecido en la Ley
                                1581 de 2012, REDAUTOS adoptará las medidas
                                técnicas, humanas y administrativas que sean
                                necesarias para otorgar seguridad a los
                                registros evitando su adulteración, pérdida,
                                consulta, uso o acceso no autorizado o
                                fraudulento. El personal que realice el
                                tratamiento de los datos personales ejecutará
                                los protocolos establecidos con el fin de
                                garantizar la seguridad de la información.
                            </p>
                            <p>
                                <b>11. VIGENCIA:</b> La presente Política de
                                Protección de Datos de REDAUTOS rige a partir
                                del día 2 de Octubre de 2020 y de manera
                                indefinida, por lo que su contenido obliga a
                                REDAUTOS mientras permanezcan vigentes las
                                relaciones contractuales, comerciales, laborales
                                o meramente informativas con los titulares de
                                las informaciones y datos personales. Lo
                                anterior, sin perjuicio del derecho de los
                                titulares a solicitar la revocatoria de la
                                autorización para el tratamiento de sus datos e
                                informaciones personales.
                            </p>
                            <p>
                                En todo caso, y aun cuando medie solicitud de
                                revocatoria de la autorización para el
                                tratamiento, REDAUTOS advierte que los datos
                                personales serán conservados cuando así se
                                requiera para el cumplimiento de una obligación
                                de carácter legal o contractual que hubiere
                                surgido entre la empresa y el respectivo
                                titular.
                            </p>
                            <p>
                                REDAUTOS se reserva el derecho a hacer ajustes
                                al contenido de la presente Política de
                                Protección de Datos cuando las actividades del
                                tratamiento y/o la finalidad del tratamiento de
                                los datos e información personal cambien, o
                                cuando los cambios normativos en la materia lo
                                justifiquen. En todo caso, dichos cambios serán
                                debidamente comunicados a los titulares a través
                                de los mecanismos eficientes de comunicación
                                comúnmente utilizados en el giro ordinario de
                                las relaciones comerciales o promocionales que
                                con ellos se sostienen.
                            </p>
                            <p>
                                Atentamente, <br />
                                <b>REDAUTOS</b>
                            </p>
                            <h5 class="text-center text-uppercase">
                                PROTOCOLO ADICIONAL DE MANEJO DE LA INFORMACIÓN
                                PERSONAL REDAUTOS
                            </h5>
                            <p>
                                A continuación se enuncian algunos parámetros
                                particulares frente al manejo de información
                                personal que rigen la actividad desarrollada por
                                <b>REDAUTOS</b>, en adelante <b>REDAUTOS</b> El
                                presente documento se desarrolla en cumplimiento
                                de la Ley 1581 de 2012, “Por la cual se dictan
                                disposiciones generales para la protección de
                                datos personales”, según la cual todas las
                                entidades públicas o privadas que manejen datos
                                personales, deberán adoptar un manual interno de
                                políticas y procedimientos para garantizar el
                                adecuado cumplimiento de la ley y en especial,
                                para asegurar el efectivo ejercicio de los
                                derechos de los titulares. Toda la información
                                recibida por <b>REDAUTOS</b> a través de sus
                                diferentes canales de comunicación, en medios
                                digitales o impresos, y que conforma nuestras
                                bases de datos, obtenidos de clientes,
                                proveedores, empleados o contratistas, y demás
                                titulares de información, se rige por las
                                siguientes políticas de uso.
                            </p>
                            <p>
                                <b>Medidas de Seguridad:</b> Los datos
                                personales registrados en nuestra base de datos
                                son almacenados directamente por los encargados
                                del manejo de los mismos, limitando su acceso al
                                uso de usuarios restringidos con su debida clave
                                de acceso. En ese sentido REDAUTOS empleará
                                todas las medidas humanamente posibles para
                                evitar cualquier tipo de filtraciones a agentes
                                extraños.
                            </p>
                            <p>
                                <b>Política de Destrucción:</b> En virtud del
                                principio de finalidad de la información, esta
                                asume una naturaleza temporal y en tal medida
                                REDAUTOS, asume la responsabilidad de proceder a
                                eliminar diligentemente toda información de sus
                                bases de datos, una vez transcurridos 5 años
                                desde el último uso que se le haya dado a la
                                información. Lo anterior sin perjuicio de que el
                                titular solicite la eliminación de su
                                información en cualquier momento. Para tal
                                propósito el responsable del tratamiento de los
                                datos deberá hacer una revisión anual para
                                determinar qué información ha cumplido con el
                                periodo de existencia aquí estipulado y por
                                ende, se hace necesaria su eliminación. Una vez
                                organizado el listado de la información a
                                destruir, se verificará la existencia de copias
                                físicas o digitales de la misma, para asegurar
                                la eliminación total de la misma, para que así
                                se proceda a eliminar de la base de datos
                                digital centralizada.
                            </p>
                            <p>
                                <b> Política de Incidentes y Filtraciones:</b>
                                En caso de detectarse extravío o filtraciones de
                                información o manipulación no autorizada de la
                                misma, el Responsable del Tratamiento o el
                                Representante Legal de la sociedad, deberán
                                proceder a realizar el reporte ante la
                                Superintendencia de Industria y Comercio, por
                                medio de la página web y la Delegatura para la
                                Protección de Datos Personales. Adicionalmente
                                de ser procedente deberá interponer la denuncia
                                ante la autoridad policial competente sobre la
                                pérdida de la información a la que haya lugar.
                            </p>
                            <p>
                                <b
                                    >Suministro de Información frente a Aliados
                                    Comerciales:</b
                                >
                                Para el suministro de información a aliados
                                comerciales, el responsable del tratamiento debe
                                solicitar previamente al tercero que recibirá la
                                información la Política de Tratamiento de Datos
                                personales implementado por ellos, y sentar
                                claridad sobre la finalidad con la que se
                                transmite la información. De igual forma
                                REDAUTOS deberá asegurarse que cada información
                                que se transmita debe ser debidamente autorizada
                                su traslado por el titular con anterioridad al
                                mismo.
                            </p>
                            <p>
                                <b
                                    >Información de Prevención contra Hackers y
                                    filtración de informaciones: Recomendaciones
                                    Generales:</b
                                >
                                Mantenga su contraseña segura, en caso de
                                olvidarla REDAUTOS Company le generará una nueva
                                previa solicitud de su parte, esta nueva
                                contraseña será enviada a su correo electrónico.
                                Las recomendaciones que le damos a la hora de
                                asignar una clave son las siguientes:
                            </p>
                            <ul>
                                <li>
                                    Hacer claves de una longitud mínima de 8
                                    caracteres. Los caracteres vuelven a la
                                    contraseña más robusta.
                                </li>
                                <li>
                                    Realizar combinaciones alfanuméricas. Estas
                                    son más difíciles de descubrir, teniendo en
                                    cuenta las diversas posibilidades de
                                    combinación de los caracteres.
                                </li>
                                <li>
                                    Utilizar distintas claves para cada
                                    servicio. De esta manera, si la contraseña
                                    es revelada, será más difícil para el
                                    atacante acceder al resto de las plataformas
                                    del usuario.
                                </li>
                                <li>
                                    Evitar palabras comunes. Quienes conocen de
                                    informática pueden revelar una clave en
                                    cuestión de segundos.
                                </li>
                                <li>
                                    Tener especial cuidado al elegir la pregunta
                                    secreta que solicitan en algunas
                                    plataformas. En las redes sociales hay mucha
                                    información personal que se vuelve pública y
                                    puede ser utilizada para descifrarla.
                                </li>
                                <li>
                                    Prestar atención cuando se accede a los
                                    servicios desde espacios públicos. Existen
                                    ciertos programas que facilitan la
                                    interferencia de las plataformas y pueden
                                    almacenar las pulsaciones del teclado.
                                </li>
                                <li>
                                    Cambiar periódicamente las claves. Esto
                                    aumenta el nivel de seguridad de las
                                    credenciales.
                                </li>
                                <li>
                                    Cambiar las vocales por números. Por
                                    ejemplo, “Mi Clave es segura”: M3 Cl1v2 2s
                                    s2g5r1.
                                </li>
                                <li>
                                    Utilizar reglas mnemotécnicas, como elegir
                                    la primera letra de cada una de las palabras
                                    de una frase fácil de recordar. Por ejemplo,
                                    “Mi Clave es segura”: MCe10vs.
                                </li>
                                <li>
                                    Claves basadas en un mismo patrón. Por
                                    ejemplo, añadir al final las iniciales cada
                                    red social: MCe10vFB (Facebook ); MCe10vTR
                                    (Twitter); MCe10vsGM (Gmail).
                                </li>
                            </ul>
                            <p>
                                <u
                                    >Técnicas utilizadas por hackers para
                                    acceder a información</u
                                >
                            </p>
                            <p>
                                <u>Phishing</u>: Una forma de ingeniería social
                                donde a través de una página web o un correo
                                electrónico, un estafador se hace pasar por una
                                empresa o persona de confianza y le pide la
                                contraseña a un usuario, quien deliberadamente
                                confía y entrega la información.
                            </p>
                            <p>
                                <u>Tabnapping</u>: El usuario sin darse cuenta
                                entra en una página web muy similar a la que
                                normalmente usa, pero no se da cuenta de que la
                                dirección electrónica es diferente y así entrega
                                toda su información en un sitio web no genuino.
                            </p>
                            <p>
                                <u>Robo en el sitio web</u>: Muchos de los
                                sitios web tienen grandes debilidades en
                                seguridad, como por ejemplo almacenar los
                                nombres de usuario y contraseñas en texto claro,
                                o sea sin cifrar, lo que los hackers saben muy
                                bien cómo aprovechar.
                            </p>
                            <p>
                                <u>Brute force</u>: Se refiere a la obtención de
                                las contraseñas a través de prueba y error,
                                similar a intentar todas las combinaciones
                                posibles de una cerradura. <br />
                                La forma más conocida de ataque de fuerza bruta
                                es con un software para descifrar contraseñas,
                                que metódicamente trata con millones de
                                contraseñas en un nombre de usuario. Una
                                contraseña débil puede ser violada en cuestión
                                de horas.
                            </p>
                            <p>
                                <u>Eavesdropping</u>: Muchas personas piensan
                                que están 100% seguros porque solo visitan
                                sitios seguros y respetados, pero no saben que
                                un JavaScrip malicioso puede estar presente en
                                cualquier navegador en cualquier sistema. <br />
                                El registro de pulsaciones de teclas es algo que
                                se hace con este tipo de scripts, quedando
                                capturadas todos los usuarios y las contraseñas
                                digitadas mientras la sesión esté abierta.
                            </p>
                            <p>
                                <b>Respaldo de Videograbaciones:</b> Las
                                videograbaciones podrán estar almacenadas en un
                                servidor externo de un tercero, debiendo estar
                                disponible en un lugar visible tal información
                                al público. De igual forma el responsable del
                                tratamiento debe solicitar previamente al
                                tercero que recibirá la información la Política
                                de Tratamiento de Datos personales implementado
                                por quien administrará las grabaciones.
                            </p>
                            <p>
                                <b> Gestión de Usuarios</b> : Para el acceso a
                                la base de datos centralizada, el acceso a esta
                                es de personal restringido limitándose a
                                personal de contabilidad, activaciones de
                                producto, gerencia y cargos administrativos, y
                                comercial. Teniendo cada uno un usuario de
                                acceso con una contraseña, la cual es de uso
                                privativo de cada persona, y no podrá ser
                                compartida bajo ninguna circunstancia.
                            </p>
                            <p>
                                Información del responsable del tratamiento de
                                los datos:
                            </p>
                            <br />
                            <br />
                            <p>
                                <b>Nombre de la Empresa:</b> REDAUTOS <br />
                                <b> Nombre del Encargado:</b> JUAN MARTIN GONZALEZ POSADA
                                <br />
                                <b>Domicilio:</b> Calle 5 # 14-47
                                <br />
                                <b>Teléfono:</b> (57) 320 6660716
                                <br />
                                <b>Correo electrónico:</b>
                                servicioalcliente@redautos.com
                                <br />
                                <b>Página web:</b> www.redautos.com
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped></style>
